/**
 * @file Rounds an exact `AnalyticsFraction` half away from zero to `places`
 * decimal places and writes it as a decimal string, such as `"1234.5000"`.
 * Consumers: `goalProgress` for money, `analyticsDecimalSum` and the display
 * text. The sign is taken from the rounded magnitude, so a value that rounds
 * to zero never reads `"-0.0000"`. The denominator must be greater than 0n.
 */
import type { AnalyticsFraction } from './AnalyticsFraction.types';

export const analyticsFractionDecimal = (
  { numerator, denominator }: AnalyticsFraction,
  places: number,
): string => {
  const scale = 10n ** BigInt(places);
  const scaled = (numerator < 0n ? -numerator : numerator) * scale;
  const quotient = scaled / denominator;
  const rounded =
    2n * (scaled % denominator) >= denominator ? quotient + 1n : quotient;
  const sign = numerator < 0n && rounded > 0n ? '-' : '';
  const whole = `${sign}${rounded / scale}`;
  return places === 0
    ? whole
    : `${whole}.${(rounded % scale).toString().padStart(places, '0')}`;
};
